import StyledLinkButton from "features/shared/components/buttons/link-button/styles/StyledLinkButton.styled";
import styled from "styled-components";

import OutlinedButton from "../../shared/components/buttons/OutlinedButton.styled";

interface FormButtonsProps {
  direction: "ltr" | "rtl";
  displayInline: boolean;
}

const FormButtons = styled.div<FormButtonsProps>`
  display: ${({ displayInline }) =>
    displayInline === true ? "flex" : "block"};

  ${OutlinedButton} {
    margin-right: ${({ direction }) =>
      direction === "ltr" ? "16px" : "initial"};
    margin-left: ${({ direction }) =>
      direction === "rtl" ? "16px" : "initial"};
  }

  ${StyledLinkButton} {
    margin-top: 32px;
  }
`;

export default FormButtons;
